import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';
import router from '@/router';
import {mapActions, mapGetters} from 'vuex';

export default {
    name: 'newPromotionDermo',

    data(){
        return {
            promotionWithSamples: 1,
        }
    },

    components: {
        BaseLayout,
    },

    computed: {
        ...mapGetters({
            promotion: 'promotion/promotion',
        }),
    },

    methods: {
        ...mapActions('promotion', ['storePromotion']),
        /**
         * Edit promotion and send to our backend
         */
        submitEditPromotion() {
            const params = new FormData();
            params.append('type', 3);
            params.append('promotion_with_samples',  this.promotionWithSamples);

            api.post(`/api/promotions_edit`, params)
                .then((response) => {
                    this.storePromotion();
                    router.replace('/promotion')
                })
                .catch((error) => {
                });
        },
        /**
         * Send user back
         */
        goBack() {
            router.replace('/promotion')
        },
    },

    watch: {
        'promotion.activePromotion.promotion_with_samples': function (){
            this.promotionWithSamples = this.promotion.activePromotion.promotion_with_samples;
        }
    },

    mounted() {
        this.storePromotion();
        this.promotionWithSamples  = this.promotion.activePromotion.promotion_with_samples;
    },
}